import {createSvgIcon} from '@ui/icons/create-svg-icon';

export const ToggleRightSidebarIcon = createSvgIcon(
  <path d="M14 2H2C1.45 2 1 2.45 1 3V13C1 13.55 1.45 14 2 14H14C14.55 14 15 13.55 15 13V3C15 2.45 14.55 2 14 2ZM2.7 3.7H10V12.3H2.7V3.7Z" />,
  'ToggleRightSidebarIcon',
  '0 0 16 16',
);
